import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useSeo } from '../hooks/useSeo';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ArticleList = ({ articles }) => {
  if (!articles.length) {
    return <p data-testid="articles-empty" className="text-[14px] text-[#1E1B18]/60">New articles coming soon.</p>;
  }
  return (
    <div className="divide-y divide-[#1E1B18]/10 border-y border-[#1E1B18]/10">
      {articles.map((a) => (
        <Link key={a.slug} to={`/articles/${a.slug}`} data-testid={`article-link-${a.slug}`}
          className="group block py-7 hover:bg-[#FBF7F0] px-2 -mx-2 transition-colors">
          <p className="text-[11px] tracking-[0.25em] text-[#8B7FB8] mb-2">
            {(a.published_at || '').slice(0, 10)}
          </p>
          <h2 className="font-serif text-2xl text-[#1E1B18] mb-2 group-hover:text-[#7B6BA6] transition-colors">{a.title}</h2>
          <p className="text-[14px] text-[#1E1B18]/65 max-w-2xl">{a.excerpt}</p>
          <span className="mt-3 inline-flex items-center gap-2 text-[13px] text-[#8B7FB8]">
            Read article <ArrowRight size={13} className="group-hover:translate-x-1 transition-transform" />
          </span>
        </Link>
      ))}
    </div>
  );
};

export const usePublishedArticles = () => {
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    axios.get(`${API}/articles`).then((r) => setArticles(r.data || [])).catch(() => {});
  }, []);
  return articles;
};

export default function Articles() {
  const articles = usePublishedArticles();
  useSeo(
    'RMT Mississauga Articles & Massage Tips | Aura Lune',
    'Massage therapy tips and guides from a Registered Massage Therapist in Mississauga: lymphatic drainage, prenatal, Swedish and mobile massage.'
  );
  return (
    <div className="bg-[#F4EFE7] min-h-screen overflow-x-hidden" data-testid="articles-page">
      <Navbar />
      <section className="pt-32 pb-20 max-w-[1000px] mx-auto px-6 sm:px-8">
        <p className="text-[11px] tracking-[0.3em] text-[#8B7FB8] font-medium mb-5">JOURNAL</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#1E1B18] leading-[1.05] mb-4">
          Massage therapy articles from your Mississauga RMT
        </h1>
        <p className="text-[15px] text-[#1E1B18]/65 max-w-2xl mb-12">
          Practical guides on Swedish massage, lymphatic drainage, prenatal care and mobile massage
          in Mississauga, Streetsville and nearby neighbourhoods.
        </p>
        <ArticleList articles={articles} />
        <Link to="/mississauga-rmt" data-testid="articles-to-landing-link"
          className="mt-10 inline-block text-[13px] text-[#1E1B18]/60 hover:text-[#1E1B18] underline underline-offset-4">
          About Aura Lune — RMT in Mississauga
        </Link>
      </section>
      <Footer />
    </div>
  );
}
